let isIdentificationNumberTaken = false;

export const getIsIdentificationNumberTaken = () => isIdentificationNumberTaken;

export const setIsIdentificationNumberTaken = (isTaken: boolean) => {
  isIdentificationNumberTaken = isTaken;
};
